import { fonts, fontSize } from "config/styles/fonts";

const styles = {
  contentWrap: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    gap: "20px",
  },
  title: {
    fontSize: fontSize.xl,
    fontWeight: 1000,
  },
  stepper: {
    "& .MuiStepConnector-root": {
      ml: "4px",
    },
    "& .MuiStepLabel-root": {
      p: "6px 0",
      alignItems: "flex-start",
    },
  },
  stepLabel: {
    "& .MuiStepLabel-labelContainer": {
      color: "text.primary",
      "& .MuiStepLabel-label": {
        fontFamily: fonts.text,
      },
    },
    "& .MuiStepLabel-iconContainer .MuiSvgIcon-root": {
      width: "10px",
      height: "10px",
      mt: "3px",
    },
  },
  details: {
    display: "flex",
    justifyContent: "space-between",
    gap: "10px",
    mt: "auto",
  },
  time: {
    fontWeight: 700,
    fontSize: fontSize.l,
  },
  payment: {
    display: "flex",
    gap: "5px",
    "& .MuiTypography-root": {
      fontWeight: 700,
      fontSize: fontSize.l,
    },
  },
  footer: {
    display: "flex",
    gap: "30px",
    mt: "10px",
    "& > .MuiBox-root > .MuiBox-root > .MuiTypography-root:first-of-type": {
      fontSize: fontSize.xxxl,
    },
  },
};

export default styles;
